module.exports = __webpack_public_path__ + "img/IMG_9022_L_BlackMatted.9080b167.jpg";